const theme = {
  colors: {
    primary: "#fff",
    secondary: "#e5e5e5",
    accent: "#747fe0",
    accentLight: "#7795f8",
    accentGreen: "#90ee90",
    textGrey: "#525f7f",
    textBlack: "#000",
  },
  shadows: [
    "0 5px 10px rgba(0, 0, 0, 0.23)",
    "5px 0px 10px rgba(0, 0, 0, 0.23)",
  ],
  fonts: {
    heading: "Roboto Slab",
    body: "Ubuntu",
  },

  breakpoints: ["1020px", "720px"],
};

export default theme;
